import UIFetchService from '../Service/UIFetchService';
import React from 'react';
import { Card, Tag, Row, Col, Layout, Input, Transfer, Tree, Button, Select } from 'antd';
import { UserOutlined, DownOutlined, HomeOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';

class UserView extends React.Component {

    constructor() {
        super();

        this.state = {
            roles: {
                id: 0,
                used: [],
                unused: []
            },
            schemes: {
                all: [],
                owns: []
            },
            teams: [],
            teamsTree: {
                expendedKeys: ['staff/*', 'intern/*'],
                selectedKeys: ['staff/*']
            },
            projects: [],
            projectOptions: [],
            selectedOrigin: '',
            selectedProjectName: '',
            selectedStaffId: 0,
        }
    }

    async componentDidMount() {
        const teams = await UIFetchService.get('/api/v1/perm/teams');
        for (let team of teams) {
            this.setUpTeamIcons(team);
        }
        this.teamsTreeExpandAll(teams);
        this.setState({ teams: teams });
        this.fetchProjects()
    }

    fetchSchemas() {
        UIFetchService.get(`/api/v1/metadata/schemas/all?origin=${this.state.selectedOrigin}&projectName=${this.state.selectedProjectName}`)
            .then(all => {
                const state = this.state.schemes;
                state.all = all;
                this.setState({ schemes: state }, () => {
                    if (this.state.selectedStaffId > 0) {
                        this.fetchOwnedSchemas()
                    }
                });
            })

    }

    fetchOwnedSchemas() {
        UIFetchService.get(`/api/v1/querying_works/users/${this.state.selectedStaffId}/schemas_old?origin=${this.state.selectedOrigin}&projectName=${this.state.selectedProjectName}`)
            .then(schemas => {
                const state = this.state.schemes;
                state.owns = schemas.map(scheam => scheam.id);
                this.setState({ schemas: state });
            })
    }

    fetchProjects() {
        UIFetchService.get('/api/v1/schema/projects')
            .then(projects => this.setState({
                projects: projects,
                projectOptions: projects,
                selectedOrigin: "ODPS",
                selectedProjectName: 'bcz_datap'
            }, () => this.fetchSchemas()))
    }

    render() {
        const hasStaffSelected = this.hasStaffSelected(this.state.teamsTree.selectedKeys) !== 0;

        const handleOriginChange = (value) => {
            // if (value === 'ODPS') {
            //     this.setState({
            //         selectedOrigin: value,
            //         selectedProjectName: '',
            //         projectOptions: this.state.projects,
            //         schemes: {
            //             all: [],
            //             owns: []
            //         }
            //     })
            // } else if (value === 'Hologres') {
            //     this.setState({
            //         selectedOrigin: value,
            //         selectedProjectName: '',
            //         projectOptions: []
            //     }, () => {
            //         this.fetchSchemas()
            //     })
            // }
            this.setState({
                selectedOrigin: value,
                selectedProjectName: '',
                projectOptions: this.state.projects,
                schemes: {
                    all: [],
                    owns: []
                }
            })
        }

        const handleProjectChange = (value) => {
            this.setState({
                selectedProjectName: value
            }, () => {
                this.fetchSchemas()
            })
        }

        const tableFilterSelects = <>
            <span>数据源</span>
            <Select value={this.state.selectedOrigin} style={{ width: '35%', margin: 3 }} onChange={handleOriginChange}>
                <Select.Option key="ODPS" >MaxCompute</Select.Option>
                <Select.Option key="Hologres" >Hologres</Select.Option>
            </Select>
            <span>项目空间</span>
            <Select
                //defaultValue={this.state.selectedOrigin === 'ODPS' ? 'bcz_datap' : ''} 
                style={{ width: '35%', marginLeft: 3 }}
                value={this.state.selectedProjectName}
                onChange={handleProjectChange}>

                {this.state.projectOptions[this.state.selectedOrigin]?.map(p => (
                    <Select.Option key={p}>{p}</Select.Option>
                ))}
            </Select>
        </>;

        return (
            <div hidden={this.props.hidden}>
                <Layout>
                    <Layout.Sider theme="light" width="20%" style={{ margin: '10px' }}>
                        <Row>
                            <Col flex="100%">
                                <Input.Search
                                    allowClear
                                    //onSearch={this.teamsTreeDidSearch}
                                    onChange={this.teamsTreeDidChanged}
                                />
                            </Col>
                        </Row>
                        <div style={{ height: 20 }}></div>
                        <Row>
                            <Col flex="100%">
                                <Card>
                                    <Tree
                                        showIcon
                                        switcherIcon={<DownOutlined />}
                                        defaultExpandAll={true}
                                        defaultExpandedKeys={this.state.teamsTree.expendedKeys}
                                        defaultExpandParent
                                        onSelect={this.teamsTreeDidSelected}
                                        autoExpandParent={true}
                                        selectedKeys={this.state.teamsTree.selectedKeys}
                                        treeData={this.state.teams}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </Layout.Sider>
                    <Layout.Content style={{ margin: '10px' }}>
                        {hasStaffSelected && (<>
                            <Row>
                                <Col span={11} style={{ textAlign: 'left' }}>
                                    <Card title="可用角色">
                                        {this.state.roles.unused.map(role =>
                                        (<Tag color="#87d068">
                                            <a onClick={() => this.addStaffRole(role.key)}>{role.title}<PlusOutlined /></a>
                                        </Tag>)
                                        )}
                                    </Card>
                                </Col>
                                <Col span={12} offset={1} style={{ textAlign: 'left' }}>
                                    <Card title="已有角色">
                                        {
                                            this.state.roles.used.map(role =>
                                            (<Tag color="#f50">
                                                <a onClick={() => this.removeStaffRole(role.key)}>{role.title}<CloseOutlined /></a>
                                            </Tag>)
                                            )
                                        }
                                    </Card>
                                </Col>
                            </Row>
                            <div style={{ height: 20 }}></div>
                            <Row>
                                <Col flex="100%" style={{ textAlign: 'left' }}>
                                    <Card>
                                        <Transfer
                                            dataSource={this.state.schemes.all}
                                            targetKeys={this.state.schemes.owns}
                                            render={item => `${item.name}`}
                                            titles={[tableFilterSelects]}
                                            onChange={(targetKeys, direction, moveKeys) => {
                                                const state = this.state.schemes;
                                                state.owns = targetKeys;
                                                this.setState({ schemes: state });
                                                const uid = this.hasStaffSelected(this.state.teamsTree.selectedKeys)
                                                const request = {
                                                    origin: this.state.selectedOrigin,
                                                    projectName: this.state.selectedProjectName,
                                                    schemaIds: moveKeys
                                                }
                                                if (direction === 'right') {
                                                    UIFetchService.method('PUT', `/api/v1/querying_works/users/${uid}/schemas_old`, request);
                                                } else {
                                                    UIFetchService.method('DELETE', `/api/v1/querying_works/users/${uid}/schemas_old`, request);
                                                }
                                            }}
                                            showSearch
                                            pagination />
                                    </Card>
                                </Col>
                            </Row>
                        </>)}
                    </Layout.Content>
                </Layout>
            </div>
        )
    }

    async removeStaffRole(code) {
        const uid = this.hasStaffSelected(this.state.teamsTree.selectedKeys);
        if (uid === 0) {
            return;
        }
        const roles = await UIFetchService.method('DELETE', '/api/v1/perm/staff/' + uid + '/role', [code]);
        if (roles) {
            this.setState({ roles: roles });
            // const state = this.state.roles;
            // state.used = state.used.
            // state.unused.push(code);
            // this.setState({roles: state});
        }
        //this.setState({roles: roles});
    }

    async addStaffRole(code) {
        const uid = this.hasStaffSelected(this.state.teamsTree.selectedKeys);
        if (uid === 0) {
            return;
        }
        const roles = await UIFetchService.method('PUT', '/api/v1/perm/staff/' + uid + '/role', [code]);
        //console.log(roles);
        if (roles) {
            this.setState({ roles: roles });
            // const state = this.state.roles;
            // state.unused = state.used.filter(role => role != code);
            // state.used.push(code);
            // this.setState({roles: state});
        }
    }

    setUpTeamIcons(root) {
        if (root.leaf) {
            root.icon = <UserOutlined />
        } else {
            root.icon = <HomeOutlined />
        }
        if (root.children !== null && root.children !== undefined) {
            for (let child of root.children) {
                this.setUpTeamIcons(child)
            }
        }
    }

    teamsTreeExpandAll(teams) {
        const keys = [];

        const search = (root) => {
            //if (!root.leaf) {
            keys.push(root.key);
            //}
            if (root.children !== null && root.children !== undefined) {
                for (let child of root.children) {
                    search(child);
                }
            }
        };
        teams.forEach(search);
        //console.log(keys);
        const state = this.state.teamsTree;
        state.expendedKeys = keys;
        this.setState({ teamsTree: state });
    }

    teamsTreeDidExpand = (keys) => {
        const state = this.state.teamsTree;
        state.expendedKeys = keys;
        this.setState({ teamsTree: state });
    }

    teamsTreeDidSelected = async (keys) => {
        const state = this.state.teamsTree;
        state.selectedKeys = keys;
        this.setState({ teamsTree: state });
        const uid = this.hasStaffSelected(keys);
        if (uid > 0) {
            this.setState({ selectedStaffId: uid })

            const roles = await UIFetchService.get('/api/v1/perm/staff/' + uid + '/roles');
            this.setState({ roles: roles });

            // const schemas = await UIFetchService.get(`/api/v1/querying_works/users/${uid}/schemas`);
            // const state = this.state.schemes;
            // state.owns = schemas.map(scheam => scheam.id);
            // this.setState({ schemas: state });
            this.fetchSchemas()
        }
    }

    teamsTreeDidSearch = async (key) => {
        const teams = await UIFetchService.get('/api/v1/perm/teams?searchKey=' + encodeURI(key));
        for (let team of teams) {
            this.setUpTeamIcons(team);
        }
        this.teamsTreeExpandAll(teams);
        this.setState({ teams: teams });
    }

    teamsTreeDidChanged = (event) => {
        this.teamsTreeDidSearch(event.target.value);
    }

    hasStaffSelected(keys) {
        if (keys.length <= 0) {
            return 0;
        }
        const key = keys[0];
        const uid = parseInt(key);
        return Number.isNaN(uid) ? 0 : uid;
    }
}

export default UserView;